import useGet from "../../../hooks/useGet";
import Table from "../../../components/table";
import columns from "../product_list/column";
import useTable from "../../../hooks/useTable";
import CardContainer from "../../../components/card_container";
import {
  ADDPRODUCTLIST,
  EDITPRODUCTLIST,
} from "../../../routes/routes_name";
// import CustomModal from "../../../components/custom_modal";
import { useState } from "react";
import useDelete from "../../../hooks/useDelete";
import swal from "sweetalert";
import { useNavigate, useParams } from "react-router-dom";

const ProductListPage = () => {

  const navigate = useNavigate();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const {
    filter,
    isLoading,
    data,
    error,
    totalPages,
    handlePagination,
    // handleLimit,
    handleFilter,
  } = useGet("/v1/product-list");

  const {
    // isLoading: isLoadingPost,
    dataRemove,
    handleEdit,
    handleSelected,
    handleRemove,
  } = useTable();

    const {
        // isLoading: isLoadingDelete,
        handleDelete
    } = useDelete();

  const openModal = () => {
    setModalIsOpen(true);
  };

   const handleConfirmDelete = () => {
        if (dataRemove.length > 0) {
            swal({
                title: "Are you sure?",
                text: "Once deleted, you will not be able to recover this administrator data!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    const params = {
                        // url: `/v1/user/junk-superadmin?_id=${dataRemove[0]._id}`,
                        url: `v1/product-list/${dataRemove[0].id}`,
                        titleSuccess: 'Deleted!',
                        descSuccess: 'Administrator data has been successfully deleted.',
                    };
                    handleDelete(params).then(() => {
                        // window.location.reload();
                    });
                    // console.log(url)
                }
            });
        }
    };

  return (
    <>
      <CardContainer
        title="List of Product List"
        isHeader={true}
        addShow={dataRemove.length < 1}
        editShow={dataRemove.length === 1}
        deleteShow={dataRemove.length >= 1}
        addClick={ADDPRODUCTLIST}
        searchPlaceholder="Search code or category name"
        //         editClick={() =>
        //   handleEdit(`${EDITPRODUCTLIST}/${dataRemove[0]._id}`)
        // }
        editClick={() => {
          const selected = dataRemove[0];
          const id =
            selected?.id ||
            selected?._id;
          if (!id) {
            console.error("❌ ID NOT FOUND", selected);
            return;
          }
          console.log("🧪 dataRemove:", selected);
          // console.log("🧪 selected:", dataRemove?.[0]);
          navigate(`/master/product_list/edit_product_list/${id}`);
        }}

        detailClick={() => openModal()}
         deleteClick={handleConfirmDelete}
        onSearchChange={handleFilter}
      >
        <div className="expanded-y">
          <div className="table-content">
            <Table
              filter={filter}
              isLoading={isLoading}
              error={error}
              data={data}
              totalPages={totalPages}
              handlePagination={handlePagination}
              handleLimit={() => { }}
              handleChangeSelect={handleSelected}
              columns={columns}
            />
          </div>
        </div>
      </CardContainer>
    </>
  );
};
export default ProductListPage;
